// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__IkAyq","form":"Profile_form__M3oV2","group":"Profile_group__G0cDG"};